// extracted by mini-css-extract-plugin
export default {"content":"PaddedScrollable_content__tgVw7","small":"PaddedScrollable_small__ho+id","fullHeight":"PaddedScrollable_fullHeight__SZD7N"};